import { render, staticRenderFns } from "./Sorteios.vue?vue&type=template&id=74495042&"
import script from "./Sorteios.vue?vue&type=script&lang=js&"
export * from "./Sorteios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports